// src/js/components/product-video-pause.js
if (!customElements.get("product-video-pause")) {
  class ProductVideoPause extends HTMLElement {
    /**
     * Connected Callback
     */
    connectedCallback() {
      this.video = this.parentElement?.querySelector("video");
      this.button = this.querySelector("button");
      if (!this.video || !this.button) return;
      this.update = this.update.bind(this);
      this.video.addEventListener("play", this.update);
      this.video.addEventListener("pause", this.update);
      this.button.addEventListener("click", this.toggle.bind(this));
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.video.autoplay = false;
        this.video.pause();
      }
      this.update();
      this.hidden = false;
    }
    /**
     * Toggle
     */
    toggle() {
      if (this.video.paused) {
        this.video.play().catch(this.update);
      } else {
        this.video.pause();
      }
    }
    /**
     * Update
     * Keeps the accessible name and the icon in step with the video
     */
    update() {
      this.button.setAttribute(
        "aria-label",
        this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel
      );
      this.button.dataset.paused = String(this.video.paused);
    }
  }
  customElements.define("product-video-pause", ProductVideoPause);
}
